class SideCart {
  constructor() {
    this.sideCart = jQuery('.mad-side-cart');
    this.sideCartBackground = jQuery('.mad-side-cart__bg');
    this.sideCartClose = jQuery('.mad-cart__close');
    this.navbar = jQuery('.mad-navbar');
    this.cartButton = jQuery('.mad-cart-button');

    if (this.sideCart.length === 0) return;

    this.initialize();
  }

  initialize() {
    this.sideCart.appendTo('body');
    this.sideCartBackground.appendTo('body');

    this.setSideCartPosition();

    this.sideCart.addClass('closed');

    this.cartButton.click(() => this.openSideCart());

    this.sideCartBackground.click(() => this.closeSideCart());
    // this.sideCartClose.click(() => this.closeSideCart());
    jQuery(document.body).on('click', '.mad-cart__close', () => this.closeSideCart());

    window.addEventListener('resize', () => {
      if (this.sideCart.hasClass('closed')) {
        this.setSideCartPosition();
      } else {
        this.openSideCart();
      }
    });

    // Adjust side cart for WordPress admin bar
    this.adjustForAdminBar();
  }

  setSideCartPosition() {
    gsap.set(this.sideCart, {
      x: this.sideCart.width(),
      display: 'flex',
    });
  }

  openSideCart() {
    this.sideCart.removeClass('closed');
    gsap.to(this.sideCart, {
      x: 0,
      duration: 0.5,
    });

    gsap.set(this.sideCartBackground, {
      display: 'block',
    });
    gsap.fromTo(
      this.sideCartBackground,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 0.5,
      }
    );

    jQuery('body').addClass('no-scroll');
  }

  closeSideCart() {
    this.sideCart.addClass('closed');
    gsap.to(this.sideCart, {
      x: this.sideCart.width(),
      duration: 0.5,
    });

    gsap.set(this.sideCartBackground, {
      display: 'none',
      delay: 0.5,
    });
    gsap.to(this.sideCartBackground, {
      opacity: 0,
      duration: 0.5,
    });

    jQuery('body').removeClass('no-scroll');
  }

  adjustForAdminBar() {
    const adjustSideCart = () => {
      // Check for the presence of the WordPress admin bar
      const adminBar = jQuery('#wpadminbar');
      if (adminBar.length > 0) {
        const adminBarHeight = adminBar.outerHeight();
        this.sideCart.css({
          'margin-top': adminBarHeight,
          height: `calc(100vh - ${adminBarHeight}px)`,
        });
      }
    };

    // Adjust on document ready
    adjustSideCart();

    // Adjust on window resize
    jQuery(window).resize(adjustSideCart);
  }
}


module.exports = SideCart
